import { useRef, useLayoutEffect } from 'react';

type UseScrollPaginationProps = {
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
};

const useScrollPagination = ({
  isFetchingNextPage,
  fetchNextPage,
  hasNextPage,
}: UseScrollPaginationProps) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (!scrollRef.current) return;

    const el = scrollRef.current;

    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = el;

      if (
        scrollHeight - scrollTop <= clientHeight + 5 &&
        hasNextPage &&
        !isFetchingNextPage
      ) {
        fetchNextPage();
      }
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [scrollRef.current, fetchNextPage, isFetchingNextPage, hasNextPage]);

  return { scrollRef };
};
export default useScrollPagination;
